document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.querySelector('[data-sticky-bar]');
  if (!stickyBar) return;

  const stickyPrice = stickyBar.querySelector('[data-sticky-price]');
  const stickyAtc = stickyBar.querySelector('[data-sticky-atc]');
  const stickyVariantTrigger = stickyBar.querySelector('[data-sticky-trigger]');
  const stickyVariantText = stickyBar.querySelector('[data-sticky-variant-text]');
  const stickyVariantList = stickyBar.querySelector('[data-sticky-variant-list]');

  const sectionEl = stickyBar.closest('[data-section]');
  if (!sectionEl) return;

  const productForm = sectionEl.querySelector('form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  const mainAtcButton = productForm.querySelector('.product-form__submit');
  if (!mainAtcButton) return;

  const idInput = productForm.querySelector('input[name="id"]');
  if (!idInput) return;

  const variantsScript = sectionEl.querySelector(
    'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
  );

  let allVariants = [];
  if (variantsScript) {
    try {
      allVariants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      console.warn('Sticky bar: cannot parse variants JSON', e);
    }
  }

  const moneyFormat =
    stickyBar.dataset.moneyFormat ||
    (window.theme && window.theme.moneyFormat) ||
    '{{amount_no_decimals}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function getCurrentVariant() {
    if (!allVariants.length || !idInput.value) return null;
    const currentId = Number(idInput.value);
    if (!currentId) return null;
    return allVariants.find((v) => Number(v.id) === currentId) || null;
  }

  /* -------- ОНОВЛЕННЯ ЦІНИ ТА ОБʼЄМУ ---------- */

  function updateSticky() {
    const currentVariant = getCurrentVariant();
    if (!currentVariant) return;

    if (stickyVariantText) {
      if (currentVariant.options && currentVariant.options.length) {
        stickyVariantText.textContent = currentVariant.options[0];
      } else {
        stickyVariantText.textContent = currentVariant.title;
      }
    }

    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(currentVariant.price) + ' грн';
    }

    if (stickyVariantList) {
      const items = stickyVariantList.querySelectorAll('li');
      items.forEach((li) => {
        li.classList.toggle(
          'is-active',
          Number(li.dataset.id) === Number(currentVariant.id)
        );
      });
    }
  }

  setTimeout(updateSticky, 100);

  if (window.MutationObserver) {
    const mo = new MutationObserver(function () {
      updateSticky();
    });
    mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  sectionEl.addEventListener('change', function (event) {
    if (
      event.target.matches(
        'input[name^="options"], select[name^="options"], select[name="id"]'
      )
    ) {
      updateSticky();
    }
  });

  /* -------- СТВОРЕННЯ СПИСКУ ВАРІАНТІВ ---------- */

  if (stickyVariantList && allVariants.length) {
    stickyVariantList.innerHTML = '';

    allVariants.forEach((variant) => {
      const li = document.createElement('li');
      li.textContent =
        variant.options && variant.options.length
          ? variant.options[0]
          : variant.title;
      li.dataset.id = variant.id;
      stickyVariantList.appendChild(li);
    });
  }

  /* -------- ЗАСТОСУВАТИ ВАРІАНТ ЗІ СТІКІ ---------- */

  function applyVariantById(newId) {
    const variant = allVariants.find((v) => Number(v.id) === Number(newId));
    if (!variant) return;

    const variantRadiosRoot = sectionEl.querySelector('variant-radios');

    variant.options.forEach((value, index) => {
      let handled = false;

      if (variantRadiosRoot) {
        const fieldsets = Array.from(
          variantRadiosRoot.querySelectorAll('fieldset.js.product-form__input')
        );
        const fs = fieldsets[index];
        if (fs) {
          const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
          if (radios.length) {
            let targetRadio = null;
            radios.forEach((radio) => {
              const isMatch = radio.value == value;
              radio.checked = isMatch;
              if (isMatch) targetRadio = radio;
            });
            if (targetRadio) {
              targetRadio.dispatchEvent(
                new Event('change', { bubbles: true })
              );
            }
            handled = true;
          }
        }
      }

      if (handled) return;

      const allOptionSelects = Array.from(
        sectionEl.querySelectorAll('select[name^="options"]')
      );
      const fallbackSelect = allOptionSelects[index];
      if (fallbackSelect) {
        fallbackSelect.value = value;
        fallbackSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* -------- ПОВЕДІНКА ДРОПДАУНУ ---------- */

  if (stickyVariantTrigger && stickyVariantList) {
    stickyVariantTrigger.addEventListener('click', () => {
      const isHidden = stickyVariantList.hasAttribute('hidden');
      if (isHidden) {
        stickyVariantList.removeAttribute('hidden');
        stickyVariantTrigger.classList.add('open');
      } else {
        stickyVariantList.setAttribute('hidden', '');
        stickyVariantTrigger.classList.remove('open');
      }
    });

    stickyVariantList.addEventListener('click', (e) => {
      const li = e.target.closest('li');
      if (!li) return;

      const newId = Number(li.dataset.id);
      if (!newId) return;

      applyVariantById(newId);
      stickyVariantList.setAttribute('hidden', '');
      stickyVariantTrigger.classList.remove('open');

      setTimeout(updateSticky, 0);
    });

    document.addEventListener('click', (e) => {
      if (!stickyBar.contains(e.target)) {
        stickyVariantList.setAttribute('hidden', '');
        stickyVariantTrigger.classList.remove('open');
      }
    });
  }

  /* -------- ПОЯВА / ЗНИКНЕННЯ БАРУ ---------- */

  let lastScrollY = window.scrollY;

  function showSticky() {
    stickyBar.classList.add('product-sticky-bar--visible');
  }

  function hideSticky() {
    stickyBar.classList.remove('product-sticky-bar--visible');
  }

  hideSticky();

  window.addEventListener('scroll', function () {
    const currentY = window.scrollY;
    const goingDown = currentY > lastScrollY;
    const goingUp = currentY < lastScrollY;
    lastScrollY = currentY;

    const rect = mainAtcButton.getBoundingClientRect();
    const buttonTop = rect.top;

    // вниз — показуємо, коли кнопка дійшла до верху (300px)
    if (goingDown && buttonTop <= 300) {
      showSticky();
    }

    // вгору — ховаємо, коли кнопка повернулась у зону екрана (250px)
    if (goingUp && buttonTop >= 250 && buttonTop <= window.innerHeight) {
      hideSticky();
    }
  });

  /* -------- КНОПКА "Купити" В БАРІ ---------- */

  if (stickyAtc && mainAtcButton) {
    stickyAtc.addEventListener('click', function () {
      mainAtcButton.click();
    });
  }
});
